import { Bell } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { selectUnreadCount, useNotificationStore } from '@/store'

/**
 * The bell in the header: a dot when something is waiting, and a way in.
 *
 * A LINK TO A SCREEN, not another dropdown. Notifications used to be a dialog
 * inside the account menu; a second panel hanging off a second control would be
 * two ways to read the same list, so that dialog is gone and its menu row comes
 * here too. This goes to /notifications, which is where the tabs and "mark all
 * as read" live.
 */
export function NotificationBell() {
  const unread = useNotificationStore(selectUnreadCount)
  const navigate = useNavigate()

  return (
    <button
      type="button"
      onClick={() => navigate('/notifications')}
      /* min-h/w-11: this is a header icon a thumb has to find, and the team is
         on phones almost all of the time. */
      className="relative flex h-11 w-11 items-center justify-center rounded-full text-muted-foreground transition-colors hover:bg-accent hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      aria-label={
        unread > 0
          ? `Notifications — ${unread} unread`
          : 'Notifications'
      }
    >
      <Bell className="h-5 w-5" aria-hidden />
      {unread > 0 ? (
        /* The number, not a dot. It was a dot while the avatar next door
           carried the count; the count is here now, and "3 waiting" is worth
           more on the way past than "something is waiting".

           aria-hidden because the button's own label already says it, and
           hearing the number twice is worse than not hearing it. */
        <span
          aria-hidden
          className="absolute right-1 top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-destructive px-1 text-[10px] font-bold leading-none text-destructive-foreground ring-2 ring-background"
        >
          {unread > 9 ? '9+' : unread}
        </span>
      ) : null}
    </button>
  )
}
